<template>
    <el-dialog
        :visible="dialogVisible"
        @close="handleClose"
        class="cart_order_dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <!-- 标题 -->
        <template #title>
            <div class="cart_order_dialog_title">
                <span v-if="address_detail.address_id">{{$t("message.cart.address4")}}</span>
                <span v-else>{{$t("message.cart.address5")}}</span>
            </div>
        </template>
        <!-- 内容表单 -->
        <div class="cart_order_dialog_form_box">
            <el-form
                :model="form" 
                :rules="rules"
                ref="addresRule"
                label-width="100px"
                size="mini">
                <!-- 收货人 -->
                <el-form-item
                    :label="$t('message.cart.form1')"
                    prop="consignee">
                    <el-input
                        v-model="form.consignee"
                        class="cart_order_dialog_input">
                    </el-input>
                </el-form-item>
                <!-- 联系电话 -->
                <el-form-item
                    :label="$t('message.cart.form2')"
                    prop="mobile">
                    <el-input
                        v-model="form.mobile"
                        class="cart_order_dialog_input">
                    </el-input>
                </el-form-item>
                <!-- 详细地址 -->
                <el-form-item
                    :label="$t('message.cart.form3')"
                    prop="address">
                    <el-input
                        v-model="form.address"
                        class="cart_order_dialog_input">
                    </el-input>
                </el-form-item>
                <!-- 电子邮箱 -->
                <el-form-item
                    :label="$t('message.cart.form4')"
                    prop="email">
                    <el-input
                        v-model="form.email"
                        class="cart_order_dialog_input">
                    </el-input>
                </el-form-item>
                <!-- 传真 -->
                <el-form-item
                    :label="$t('message.cart.form5')"
                    prop="fax">
                    <el-input
                        v-model="form.fax"
                        class="cart_order_dialog_input">
                    </el-input>
                </el-form-item>
                <!-- 是否默认 -->
                <el-form-item>
                    <el-checkbox
                        v-model="form.is_default">
                        {{$t("message.cart.isdefault")}}
                    </el-checkbox>
                </el-form-item>
            </el-form>
        </div>
        <template #footer>
            <div>
                <el-button
                    type="primary"
                    @click="checkIdNum">
                    <span>{{$t("public.confirmBtn")}}</span>
                </el-button>
                <el-button
                    @click="handleClose">
                    <span>{{$t("public.cancelBtn")}}</span>
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
    data() {
        return {
            form: {
                consignee: "",
                address: "",
                mobile: "",
                email: "",
                fax: "",
                is_default: false
            },
            rules: {
                consignee: [
                    { required: true, message: this.$t("message.cart.rule1"), trigger: 'blur' }
                ],
                address: [
                    { required: true, message: this.$t("message.cart.rule2"), trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: this.$t("message.cart.rule3"), trigger: 'blur' }
                ],
                // email: [
                //     { required: true, message: this.$t("message.cart.rule4"), trigger: 'blur' }
                // ]
            }
        }
    },
    computed: mapState({
        power: state => state.user.power,
        dialogVisible: state => state.dialogVisible,
        address_detail: state => state.user.address_detail,
    }),
    methods: {
        ...mapMutations([
            "handleDialog",
            "setAddressDetail",
        ]),
        ...mapActions([
            "handleAddAddress",
            "getCartAddress"
        ]),
        handleClose(){ // 关闭模态框
            this.handleDialog(false);
            this.setAddressDetail({});
            this.form = {
                consignee: "",
                address: "",
                mobile: "",
                email: "",
                fax: "",
                is_default: false
            }
        },
        setForm(val){ // 编辑修改时写入表单参数
            if(!!val.address_id){
                this.form = {
                    consignee: val.consignee,
                    address: val.address,
                    mobile: val.mobile,
                    email: val.email,
                    fax: val.fax,
                    is_default: !val.status
                }
            }
        },
		//判断电子邮箱是否输入正确
		checkIdNum() {
		  const reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
		  if (!this.form.email) {
			this.handleAddress();
		  } else if (!reg.test(this.form.email)) {
			  this.$message({
			      showClose: true,
			      message: '请填写正确的邮箱',
			      type: "error"
			  })
			 return	
		  }else{
			  this.handleAddress();
		  }
		},
        handleAddress(){ // 添加 & 修改地址
            let allow = this.power.includes(0) || this.power.includes(111) || this.power.includes(3);
            this.$refs.addresRule.validate((valid) => {
                if(valid){
                    if(!allow){ // 无权限拦截
                        this.$message({
                            showClose: true,
                            message: this.$t("message.cart.errmsg2"),
                            type: "error"
                        })
                        return;
                    }
                    if(this.address_detail.address_id){ // 修改
                        this.handleAddAddress({
                            address_id: this.address_detail.address_id,
                            consignee: this.form.consignee,
                            address: this.form.address,
                            mobile: this.form.mobile,
                            email: this.form.email,
                            fax: this.form.fax,
                            status: this.form.is_default? 0: 1,
                            url: "/index/address/editpost"
                        }).then((res) => {
                            this.handleClose();
                            this.$message({
                                showClose: true,
                                message: this.$t("public.modifySucc"),
                                type: "success"
                            })
                            setTimeout(() => {
                                this.getCartAddress();
                            }, 1000)
                        })
                    }else{ // 添加
                        this.handleAddAddress({
                            consignee: this.form.consignee,
                            address: this.form.address,
                            mobile: this.form.mobile,
                            email: this.form.email,
                            fax: this.form.fax,
                            status: this.form.is_default? 0: 1,
                        }).then((res) => {
                            this.handleClose();
                            this.$message({
                                showClose: true,
                                message: this.$t("public.addSucc"),
                                type: "success"
                            })
                            setTimeout(() => {
                                this.getCartAddress();
                            }, 1000)
                        })
                    }
                }else{
                    return false;
                }
            });
        }
    },
    watch: {
        address_detail: {
            handler: "setForm",
            immediate: true
        }
    },
}
</script>

<style scoped>
/* 模态框 */
.cart_order_dialog>>>.el-dialog__body{
    padding-bottom: 0;
}
/* 模态框标题 */
.cart_order_dialog_title>span{
    font-size: 18px;
}
/* 表单盒子 */
.cart_order_dialog_form_box{
    width: 500px;
    margin: 0 auto;
}
.cart_order_dialog_input{
    width: 300px;
}
</style>
